import React from "react";
import "./FlipCard.css";

/**
 * FlipCard - Componente reutilizable para tarjetas con efecto flip 3D
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.frontContent - Contenido del frente de la tarjeta
 * @param {React.ReactNode} props.backContent - Contenido del reverso de la tarjeta
 * @param {number} props.index - Índice para animación stagger
 * @param {string} props.className - Clases CSS adicionales
 * @param {string} props.variant - Variante de la tarjeta ('default', 'project')
 * @param {Object} props.ariaLabel - Etiqueta ARIA para accesibilidad
 * @param {Object} props.role - Rol ARIA (por defecto 'group')
 */
const FlipCard = ({
    frontContent,
    backContent,
    index = 0,
    className = "",
    variant = "default",
    ariaLabel,
    role = "group"
}) => {
    const cardClasses = `card ${variant === 'project' ? 'proyecto-card-portafolio' : ''} ${className}`.trim();

    return (
        <div
            className={cardClasses}
            style={{ "--i": index + 1 }}
            tabIndex={0}
            role={role}
            aria-label={ariaLabel}
        >
            <div className="card-front">
                {frontContent}
            </div>
            <div className="card-back">
                {backContent}
            </div>
        </div>
    );
};

export default React.memo(FlipCard);
